import { render, staticRenderFns } from "./HandleVerifyEmail.vue?vue&type=template&id=d5c7251e&scoped=true&"
import script from "./HandleVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./HandleVerifyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c7251e",
  null
  
)

export default component.exports